function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
}

function base64ToFile(
  base64: string,
  filename: string,
  type: string
): File & { objectURL: string } {
  const arr = base64.split(',');
  const mime = type || arr[0].match(/:(.*?);/)?.[1] || 'application/octet-stream';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  const blob = new Blob([u8arr], { type: mime });
  const file = new File([blob], filename, { type: mime }) as File & { objectURL: string };

  file.objectURL = URL.createObjectURL(file);
  return file;
}

export { fileToBase64, base64ToFile };
